module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "intro-layer"
  }, [_c('p', {
    staticClass: "intro-layer-text"
  }, [_vm._v("\n            망설이지마세요!"), _c('br'), _vm._v("\n            만남의 장소를 대신 정해드립니다!"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("지도를 클릭해서 위치를 추가하세요.")])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrap"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_vm._v("닫기")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.disable
    }
  }, [_vm._v("다시는 열지 않기")])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07aa0740"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/introLayer.vue
// module id = 48
// module chunks = 0